import React, { useEffect } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';
import { Nav, NavDropdown } from 'react-bootstrap';
import cx from 'classnames';
import { useSelector, useDispatch } from 'react-redux';
import { useQuery } from '@apollo/client';

import Link from '../Link';
import HeaderModal from '../HeaderModal/HeaderModal';

import history from '../../history';
import { formatLocale } from '../../helpers/formatLocale';
import { openHeaderModal } from '../../actions/siteadmin/modalActions';
import { adminLogout } from '../../actions/siteadmin/logout';
import { choseToTheme } from '../../actions/currency/getCurrencyRates';
import messages from '../../locale/messages';
import { toggleAdminMenu } from '../../actions/siteadmin/modalActions';

import CheckUserStatusQuery from './getCheckUserStatus.graphql';
import { AdminHeaderDarkModeIcon, AdminHeaderGoToMainSiteIcon, AdminHeaderLanguageIcon, AdminHeaderLightModeIcon, AdminHeaderLogoutIcon } from '../Common/Assets/SVGIcon/AdminHeaderIcon';

import s from './AdminHeader.css';

const AdminHeader = ({ intl }) => {
  const dispatch = useDispatch();
  const selectedTheme = useSelector(state => state.currency.theme);
  const isOpenMenu = useSelector(state => state?.adminModalStatus?.isOpenAdminMenu);
  const currentLocale = intl.locale;

  const { data: checkLoginUserExist, loading: userExistloading } = useQuery(CheckUserStatusQuery, {
    pollInterval: 60000 // 1 minute
  });

  const getAdminUserExists = checkLoginUserExist?.getAdminUserExists;

  useEffect(() => {
    if (!userExistloading && getAdminUserExists?.userExistStatus) {
      dispatch(adminLogout());
      window.location.reload();
    }
  }, [userExistloading, getAdminUserExists, dispatch]);

  const handleChange = () => {
    dispatch(openHeaderModal('languageModal'));
  };

  const goToMainSite = e => {
    e.preventDefault();
    history.push('/');
  };

  const handleThemeChange = (theme) => {
    dispatch(choseToTheme(theme));
  };

  return (
    <header className={cx(s.adminHeaderContainer, 'adminHeaderContainerRtl', 'hidden-print')}>
      <HeaderModal />
      <div className={s.adminHeaderMenuIcon}>
        <div className={s.hamburger} onClick={() => dispatch(toggleAdminMenu(!isOpenMenu))} >
          <span className={s.iconBar}></span>
          <span className={s.iconBar}></span>
          <span className={s.iconBar}></span>
        </div>
      </div>
      <Nav className={s.adminHeaderNavMenuContainer}>
        <NavDropdown
          title={
            <>
              <span className={cx(s.adminHeaderMenuItem, s.adminHeaderDropdownMenuItem)}>
                {selectedTheme === 'light' && <AdminHeaderLightModeIcon className={s.adminHeaderMenuItemIcon} />}
                {selectedTheme === 'dark' && <AdminHeaderDarkModeIcon className={s.adminHeaderMenuItemIcon} />}
                <span className={s.adminHeaderMenuItemText}>
                  {selectedTheme === 'light' && <FormattedMessage {...messages.lightMode} />}
                  {selectedTheme === 'dark' && <FormattedMessage {...messages.darkMode} />}
                </span>
              </span>
            </>
          }
          id="basic-nav-dropdown1"
          className={"adminHeaderDropdownMenu"}
        >
          <NavDropdown.Item to="#" onClick={() => handleThemeChange('light')}>
            <div className={cx(s.adminHeaderDropdownMenuInnerWrapper, selectedTheme === 'light' && s.adminHeaderDropdownMenuSelect)}>
              <AdminHeaderLightModeIcon className={s.adminHeaderMenuItemIcon} />
              <FormattedMessage {...messages.lightMode} />
            </div>
          </NavDropdown.Item>
          <NavDropdown.Item to="#" onClick={() => handleThemeChange('dark')}>
            <div className={cx(s.adminHeaderDropdownMenuInnerWrapper, selectedTheme === 'dark' && s.adminHeaderDropdownMenuSelect)}>
              <AdminHeaderDarkModeIcon className={s.adminHeaderMenuItemIcon} />
              <FormattedMessage {...messages.darkMode} />
            </div>
          </NavDropdown.Item>
        </NavDropdown>
        <div onClick={handleChange} className={s.adminHeaderMenuItem} tabIndex={0}>
          <AdminHeaderLanguageIcon className={s.adminHeaderMenuItemIcon} />
          <span className={s.adminHeaderMenuItemText}>
            {formatLocale(currentLocale)}
          </span>
        </div>
        <Link onClick={goToMainSite} className={s.adminHeaderMenuItem}>
          <AdminHeaderGoToMainSiteIcon className={s.adminHeaderMenuItemIcon} />
          <span className={s.adminHeaderMenuItemText}>
            <FormattedMessage {...messages.goToMainSite} />
          </span>
        </Link>
        <Link to="/login" onClick={() => dispatch(adminLogout())} className={s.adminHeaderMenuItem}>
          <AdminHeaderLogoutIcon className={s.adminHeaderMenuItemIcon} />
          <span className={s.adminHeaderMenuItemText}>
            <FormattedMessage {...messages.logout} />
          </span>
        </Link>
      </Nav>
    </header>
  );
};

export default injectIntl(withStyles(s)(AdminHeader));